'use strict';

module.exports = require('../5/CheckObjectCoercible');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2021/RequireObjectCoercible.js
// module id = 421
// module chunks = 4